$(document).ready(function() {

Fancybox.bind('[data-fancybox]', {
  //groupAttr: false,
  Thumbs: {
    autoStart :false,
    Carousel: {
      Sync: {
        friction: 0.9,
      },
    },
  },
});

  $('.scrollTop').click(function() {
    $('html, body').animate({scrollTop: 0}, 800);
    return false;
  });
  $(window).scroll(function() {
    if ($(this).scrollTop() > 150) {   
        $('.scrollTop').fadeIn();     
        $('.headerWrap').addClass('has_sticky');
    } else {
        $('.scrollTop').fadeOut();
        $('.headerWrap').removeClass('has_sticky');
    }
  }); 


 $('.homepageslide').slick({
  infinite: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true, 
  autoplay: true,
  autoplaySpeed: 2000
});

/* Testimonials Slide */
 $('.testimonials_slide').slick({
  // infinite: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  autoplay: false,
  adaptiveHeight: true,
  //appendArrows: '.slideArrow'
});

/* Video Slide */
 $('.videoSlider').slick({
  infinite: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false, 
  autoplay: true,
  autoplaySpeed: 90000,
  //appendArrows: '.slideArrow'
});



 /* Bespoke Slide */
 if($('.bespokeSlider').length){
   $('.bespokeSlider').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false, 
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
 
  ]
  });
}

/* Custom Popup */
$('.popclick').off('click');
  $(document).on('click', '.popclick', function(e) {
    var linkAttrib = $(this).attr('data-pop');           
    $('#' + linkAttrib).addClass("popVisible");
    $('body').addClass('bodyFixed');
  });
  $(document).on('click', '.closePopup, .overlayer, .backBtn', function(e) {
    $('.popupMain').removeClass("popVisible");
    $('body').removeClass('bodyFixed');
  });


/*
  var interval = null;
  interval = setInterval(updateDiv,3000);

  function updateDiv(){
    if (!$('#insta-feed').is(':empty')){ 
      alert('Done'); 
      $('#insta-feed').slick({
        // infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        autoplay: false,
        adaptiveHeight: true,
        //appendArrows: '.slideArrow'
      });
      clearInterval(interval); // stop the interval
    }
      console.log(111); 
  }
*/  

$(".viewmorebtn").click(function(){
      var moredetail=$(this).attr("data-detail");
      $("#"+moredetail).toggleClass('viewbox_active');
      $(this).toggleClass("active");

    if($(this).hasClass('active')){
      $(this).text("Show Less");
    }else{
      $(this).text("Show More");
    }
});
 

/* Mobile menu */  
$('.menuIcon').click(function() {
  $(this).toggleClass('menu-close');
  $('.navigationBar').toggleClass('slideMenu'); 
  $('body').addClass('bodyFixed');   
});

$('.sidebar-overlay, .closeMenu').click(function() {
  $('.menuIcon').removeClass('menu-close');        
  $('.navigationBar').removeClass('slideMenu');
  $('body').removeClass('bodyFixed');
});

$('.mobile-nav li:has(ul), .widgetBox ul li:has(ul)').prepend('<span class="arrow"></span>');
$('.arrow').click(function() {
  $(this).siblings('ul').slideToggle('slow'); 
  $(this).toggleClass('minus'); 
});

$('.mob_filter').click(function(){
  $(this).toggleClass('closeFilter');
  $('.filterBox').toggleClass('slide');
  $('body').toggleClass('scrollOff'); 
});

$('.filterBox .widgetTitle, .sidebar-overlay').click(function(){
  $('.mob_filter').removeClass('closeFilter');
  $('.filterBox').removeClass('slide');
  $('body').removeClass('scrollOff');
});

$('.arrivalsSlider').slick({  
    // infinite: true,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    //appendArrows: '.slideArrowtwo',
    responsive: [
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        // infinite: true,
        //arrows: false,
        //dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        //arrows: false,
        //dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: true,
       // arrows: false,
        //dots: true
      }
    }    
  ]
  });

$('.relatedProducts').slick({
    // infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    //appendArrows: '.slideArrowtwo',
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: true
      }
    }    
  ]
  });
$('.recommendationsList').slick({
    // infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    //appendArrows: '.slideArrowtwo',
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: true
      }
    }    
  ]
  });

$('.blognewsmain').slick({  
    // infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    appendArrows: '.slideArrowtwo',
    responsive: [
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        // infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      }
    }    
  ]
  });


 $(window).load(function() { 
     var sidebar = new StickySidebar('#sidebar', {
        containerSelector: '#main-content',
        innerWrapperSelector: '.sidebar__inner',
        topSpacing: 70,
        bottomSpacing: 20
      });
  });

 /* QTY field */  
  $(document).on("click",".qtyplus",function(e) {
    e.preventDefault();
    var currentVal = parseInt($('#quantityField').val());
    if (!isNaN(currentVal)) {
      $('#quantityField').val(currentVal + 1);
    } else {
      $('#quantityField').val(1);
    }
  });
    
  $(document).on("click",".qtyminus",function(e) {
    e.preventDefault();
    var currentVal = parseInt($('#quantityField').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $('#quantityField').val(currentVal - 1);
    } else {
      $('#quantityField').val(1);
    }
  });

  /* Product gallery */
  $('.galleryMain').slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    fade: false,
    arrows: true,
    dots: false,
    autoplay: false,
    asNavFor: '.galleryThumb',
    fade: true,
    autoplaySpeed: 4000,
    responsive: [
    {
      breakpoint: 767, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // infinite: true,
        dots: true
      }
    }
  ]
});
 
$('.galleryThumb').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    autoplay: false,
   // autoplaySpeed: 5000,
    asNavFor: '.galleryMain',
    arrows: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
              vertical: false,
              verticalSwiping: false,
              dots:false,
              arrows: false,
            }
        },{
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false,
              dots:false,
              arrows: false,
            }
        }
    ]
});


  

});

function readyFn( jQuery ) {
    $('.eapps-link').remove();
    $('.instagramFeed').css('opacity', '1');    
}
$( window ).on( "load", readyFn );

/*$(window).load(function(){
  setTimeout(function(){ 
    $('.eapps-link').remove();
  }, 3000);
 
});*/